import * as React from 'react';
import { className } from '../../../core/utilities/classnames.utils.js';
import { composeEventHandlersUtil } from '../../utilities/compose-event-handlers.util.js';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
const TextInputWithFloatingLabelContext = /*#__PURE__*/ React.createContext(null);
const useTextInputWithFloatingLabelContext = ()=>React.useContext(TextInputWithFloatingLabelContext);
const useNonNullishTextInputWithFloatingLabelContext = ()=>useNonNullishContext(TextInputWithFloatingLabelContext);
function useFloatingLabelProps(props) {
    const { id , className: className$1 , placeholder: customPlaceholder , value , defaultValue , onChange: customOnChange  } = props;
    // communicate the id up to the TextInputWithFloatingLabel comp if necessary
    const withFloatingLabelContext = useTextInputWithFloatingLabelContext();
    const hasFloatingLabel = withFloatingLabelContext !== undefined;
    const setInputId = withFloatingLabelContext === null || withFloatingLabelContext === void 0 ? void 0 : withFloatingLabelContext.setInputId;
    React.useEffect(()=>{
        if (setInputId === undefined) {
            return;
        }
        setInputId(id);
        return ()=>{
            setInputId(undefined);
        };
    }, [
        id,
        setInputId
    ]);
    // if there's a floating label, we need to have a non-empty placeholder or else it won't work.
    // this is certainly a hack.
    // if no placeholder was provided, we need to add _something_
    // the tricky part is the screen readers will read the label content AND the placeholder content
    // and there's no way to "hide" the placeholder content from assistive tech
    // so we need to put something in there that's not a terrible experience for screen reader users
    // we _could_ just copy the label text into the placeholder, but screen readers would read the same text twice which is annoying
    // it can't be a word/phrase like "ignore this" because we need to support localization
    const placeholder = customPlaceholder !== null && customPlaceholder !== void 0 ? customPlaceholder : ' ';
    // we need to keep track of whether or not the input is empty so that we can add/remove
    // some classes to support the floating label
    // if value is undefined, the initialValue will be defaultValue
    const initialValue = value === undefined ? defaultValue : value;
    const [isEmpty, setIsEmpty] = React.useState(initialValue === undefined || initialValue === '');
    if (!hasFloatingLabel) {
        return props;
    }
    return _object_spread_props(_object_spread({}, props), {
        className: className({
            'swan-polyfill-nonempty': hasFloatingLabel && !isEmpty
        }, {
            'swan-polyfill-empty': hasFloatingLabel && isEmpty
        }, className$1),
        value,
        defaultValue,
        placeholder,
        onChange: composeEventHandlersUtil(customOnChange, (e)=>{
            setIsEmpty(e.target.value === '');
        })
    });
}

export { TextInputWithFloatingLabelContext, useFloatingLabelProps, useNonNullishTextInputWithFloatingLabelContext, useTextInputWithFloatingLabelContext };
